import { render, staticRenderFns } from "./PillarChart.vue?vue&type=template&id=15b10602&scoped=true&"
import script from "./PillarChart.vue?vue&type=script&lang=js&"
export * from "./PillarChart.vue?vue&type=script&lang=js&"
import style0 from "./PillarChart.vue?vue&type=style&index=0&id=15b10602&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b10602",
  null
  
)

export default component.exports